export function getTopLevelPath() {
    return window.location.pathname.split("/")[1]
}
